import { render } from "./Departments.vue?vue&type=template&id=5f287a71&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=ts"
export * from "./Departments.vue?vue&type=script&lang=ts"

import "./Departments.vue?vue&type=style&index=0&id=5f287a71&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f287a71"

export default script